<template>
	<div class="body-content">
		<navbar :title="$t('basic.navText')"></navbar>
		<div class="account-wrapper">
	  		<div class="account-form success-content">
	  			<img src='../../assets/success.png' class="success-img">
	  			<div class="success-title">{{ $t("basic.successText") }}</div>
	  			<div class="form-row">
	  				<button class="czur-style" type="button" @click='backToBasic'>{{ $t("basic.finishText") }}</button>
	  			</div>
	  		</div>
	  	</div>
	  	<LoginCheck v-on:nologin="withOutLogin"></LoginCheck>
	</div>
</template>
<script>
import navbar from 'components/nav/nav'
import LoginCheck from 'components/loginCheck/loginCheck'
import Config from 'common/script/config.js'
import Validate from 'common/script/validate.js'
export default {
	name: 'updateSuccess',
	components: {
		navbar,
		LoginCheck
	},
	methods: {
		withOutLogin: function (argument) {
  			window.location.href = '/index.html'
  		},
		backToBasic: function () {
        if (this.$route.params.type === 'low') {
          var callback = Config.getReqParam('callback')
          if (!Validate.stringEmpty(callback)) {
            callback = Config.appendParam(callback, 'token', Config.cookieGet(Config.COOKIE_KEY.TOKEN))
            callback = Config.appendParam(callback, 'u_id', Config.cookieGet(Config.COOKIE_KEY.U_ID))
            // console.log(callback)
            window.location.href = callback
          } else {
            Config.setLocalStore('request_flag', 1)
            window.location.href = Config.DEFAULT_PAGE
          }
          return
        }
	     	this.$router.push('/baiscPage')
    }
	},
	created: function () {
		Config.setLocalStore('request_flag', 0)
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	img.success-img
		width 0.71rem
		height 0.5rem
		margin-top 1.17rem
		margin-bottom 0.45rem
	.success-content
		text-align center
	.success-title
		font-size 0.3rem
		color #272f44
		margin-bottom 0.9rem
</style>



// WEBPACK FOOTER //
// updateSuccess.vue?84ccc200